/**
 * Test IDs for QA automation.
 */
export const testIds = {
  analyticsGraphXAxisDimension: "analytics-graph-x-axis-dimension",
  analyticsGraphXAxisDimensionOption: "analytics-graph-x-axis-dimension-option",
  analyticsGraphGroupByDimension: "analytics-graph-group-by-dimension",
  analyticsGraphGroupByDimensionOption: "analytics-graph-group-by-dimension-option",
} as const;
